"use strict";
//import smoothscroll from "smoothscroll-polyfill";
import { addEvent } from "./addEvent/addEvent";
import { isMobile } from "./isMobile/isMobile";
import { smoothScrollbarInit } from "./smoothScrollbar/smoothScrollbar";
import { lazyLoadImage } from "./lazyLoading/lazyLoading";
import { ajaxFormClass } from "./form/form";
import { showMoreInfo } from "./showMoreInfo/showMoreInfo";
import { sendOnChange } from "./form/sendOnChange";
import { confirmCancel } from "./form/confirmCancel";

import $ from "jquery";
window.jQuery = $;
window.$ = $;

$.event.special.touchstart = {
  setup: function (_, ns, handle) {
    this.addEventListener("touchstart", handle, { passive: true });
  },
};

document.addEventListener("DOMContentLoaded", DOMContentLoadedStart);
addEvent(window, "load", function () {
  afterLoadStart();
});

addEvent(window, "resize", function () {
  resize();
});

addEvent(window, "scroll", function () {
  scroll();
});

/*----- START FUNCTION -----*/
function DOMContentLoadedStart() {
  if (!isMobile() && !document.body.classList.contains("macos"))
    window.smoothScroll = smoothScrollbarInit({ damping: 0.1 });

  pageScroled();
  forms();
  showMoreInfoInit();
  sendOnChange();
  confirmCancel();

  if (isMobile()) {
    $("body").addClass("mobile");
  }
}

function afterLoadStart() {
  lazyLoadImage(document.querySelectorAll("[data-images]"));
}

function resize() {
  pageScroled();
}

function scroll() {
  pageScroled();
}

/*----- CODE BELOW -----*/
function showMoreInfoInit() {
  const elements = document.getElementsByClassName("more-info-list");

  Array.from(elements).forEach((elm) => {
    new showMoreInfo({
      mainContainer: elm,
    });
  });
}

function forms() {
  let ajaxForms = $(".ajax-form");

  ajaxForms.each((idx, form) => {
    new ajaxFormClass(form);
  });
}

function pageScroled() {
  const className = "page-scrolled";
  const scrollBreakPoint = 10;

  let scroll = 0;

  if (window.smoothScroll) {
    window.smoothScroll.addListener(({ offset }) => {
      scroll = offset.y;

      if (scroll >= scrollBreakPoint) {
        document.body.classList.add(className);
      } else {
        document.body.classList.remove(className);
      }
    });
  } else {
    scroll = $(window).scrollTop();

    if (scroll >= scrollBreakPoint) {
      document.body.classList.add(className);
    } else {
      document.body.classList.remove(className);
    }
  }
}
